"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_1 = require("./styled");

var Grid_1 = __importDefault(require("../../../Grid"));

var ButtonRadioOptions =
/** @class */
function (_super) {
  __extends(ButtonRadioOptions, _super);

  function ButtonRadioOptions() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleClick = function () {
      var _a = _this.props,
          onClick = _a.onClick,
          option = _a.option;
      onClick(option);
    };

    _this.renderLabel = function () {
      var _a = _this.props,
          option = _a.option,
          isActive = _a.isActive;

      if (option.secondaryLabel) {
        return react_1.default.createElement(Grid_1.default.Container, {
          cols: "1fr 1fr",
          style: {
            width: '100%'
          },
          colGap: true
        }, react_1.default.createElement(Grid_1.default.Cell, null, option.label), react_1.default.createElement(Grid_1.default.Cell, {
          justifySelf: "end"
        }, react_1.default.createElement(styled_1.SecondaryLabel, {
          active: isActive
        }, option.secondaryLabel)));
      }

      return option.label;
    };

    return _this;
  }

  ButtonRadioOptions.prototype.render = function () {
    var _a = this.props,
        isActive = _a.isActive,
        orientation = _a.orientation;
    var RadioOption = orientation === 'vertical' ? styled_1.VerticalButtonRadioOption : styled_1.HorizontalButtonRadioOption;
    return react_1.default.createElement(RadioOption, {
      onMouseDown: this.handleClick,
      active: isActive,
      onClick: this.handleClick
    }, this.renderLabel());
  };

  return ButtonRadioOptions;
}(react_1.PureComponent);

exports.ButtonRadioOptions = ButtonRadioOptions;
exports.default = ButtonRadioOptions;